export default __webpack_public_path__ + "static/media/doctor6.3fc25c97.jpg";